import {CheckCircleFillIcon} from '@primer/octicons-react'
import {mergeabilityStatus, Status} from '@github-ui/mergebox/helpers/mergeability-status'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useMergeabilityData} from './use-mergeability-data'
import {OverviewMergeControl} from './shared/OverviewMergeControl'

export function shouldShowReadyToMerge(data: ReturnType<typeof useMergeabilityData>) {
  return (
    !!data &&
    mergeabilityStatus({
      pullRequest: data.mergeBoxPullRequest,
      mergeRequirements: data.mergeRequirements,
      statusChecksData: data.statusChecksData,
    }) === Status.Mergeable
  )
}

// Renders for the author/assignees when the pull request is mergeable ("Ready to merge"),
// offering the relevant merge action so they can complete the merge.
export function ReadyToMerge({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!shouldShowReadyToMerge(data)) return null

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckCircleFillIcon} variant="success" emphasized />}
      emphasizedLeadingVisual
      title="Ready to merge"
      description="All requirements are met - merge the pull request."
      itemName="ready-to-merge"
      variant={variant}
      actionSlot={<OverviewMergeControl data={data} itemName="ready-to-merge" />}
    />
  )
}
